// @flow
import React from "react";
import glamorous from "glamorous";
import t from "common/i18n";
import Progress from "root/components/Progress/Progress";
import NoResults from "root/components/NoResults";
import ResultsTopBar from "root/components/ResultsTopBar";
import Breadcrumb from "../Breadcrumb";
import FileRow from "./FileRow";
import FolderRow from "./FolderRow";

import "./FolderList.scss";

type propsType = {
    items: Object[],
    selected: string[],
    selectionAction: Function,
    folderClickAction: Function,
    showProgressIndicator: ?boolean,
    metadata: {
        path_display: string
    }
};

export const GCheckboxCol = glamorous.div("flex-none pl4 pr4 pt6 pb6", { width: "7%" });
export const GFileCol = glamorous.div("flex-none pl4 pr4 pt6 pb6", { width: "12%" });
export const GNameCol = glamorous.div("flex-none pl4 pr4 pt6 pb6", { width: "43%" });
export const GModifiedCol = glamorous.div("flex-none pl4 pr4 pt6 pb6", { width: "38%" });

const FolderList = (props: propsType) => {
	const isItemSelected = (item) => !!(~props.selected.indexOf(item.id));

	const progressIndicator = props.showProgressIndicator
		? <Progress size={42} overlay/> : null;

	const onRowClick = (item: Object, isFolder: boolean, e: MouseEvent) => (isFolder ? props.folderClickAction(item)
		: props.selectionAction(item.id, e));

	const renderHeaderRow = () => <div className="table-head bg-source-bg bg-source-bg-c flex-none">
		<GCheckboxCol>
			<label/>
		</GCheckboxCol>
		<GFileCol/>
		<GNameCol>{t("dropbox.list_headers.name")}</GNameCol>
		<GModifiedCol>{t("dropbox.list_headers.modified")}</GModifiedCol>
	</div>;

	const renderRow = (item, index) => {
		const isFolder = (item[".tag"] === "folder");
		const rowKey = `tbl_row_${index}`;
		const rowProps = {
			item,
			isSelected: isItemSelected(item),
			rowClickHandler: onRowClick.bind(null, item, isFolder),
		};

		return (isFolder
			? <FolderRow {...rowProps} key={rowKey}/>
			: <FileRow {...rowProps} key={rowKey}/>);
	};

	const renderEntries = () => (props.items && props.items.length
		? props.items.map(renderRow)
		: props.showProgressIndicator ? null : <NoResults/>);

	return <div className="folder-list-container flex flex-column h-100">
		<ResultsTopBar>
			<Breadcrumb
				path={(props.metadata?.path_display || "")}
				pathClickHandler={(path) => props.folderClickAction({ path_lower: path })}/>
		</ResultsTopBar>

		<div className="folder-list flex-grow flex flex-column table-block">
			{progressIndicator}
			{renderHeaderRow()}
			<div className="table-body bg-window bg-window-c flex-grow">
				{renderEntries()}
			</div>
			<div className="bottom-spacer"/>
		</div>
	</div>;
};

export default FolderList;
